import ordering from "./order.js"; 

export default {
    __init__: [ 'ordering' ],
    ordering: [ 'type', ordering ]
};